import {
  Suspense,
  createElement,
  type ComponentType,
  type LazyExoticComponent,
  type ReactNode,
} from 'react';
import Loading from '@/components/Loading';

export function withSuspense<P extends Record<string, unknown> = Record<string, never>>(
  LazyComponent: LazyExoticComponent<ComponentType<P>>,
  options?: { fallback?: ReactNode; props?: P }
) {
  return (
    <Suspense fallback={options?.fallback ?? <Loading />}>
      {createElement(LazyComponent, (options?.props ?? ({} as P)) as P)}
    </Suspense>
  );
}
